// @ai-generated 2026-09-22T14:57:27+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { DropdownText } from '@synqo/frontend-component-library';
import { type OfferedRecord, portalName } from './portalLinkPicker';

/** One offered record in the dropdown of a link picker, under the name the portal knows it by. */
export function PortalNamePreview(record: OfferedRecord) {
    return <DropdownText content={portalName(record)} />;
}
